import type { Category } from "./types";

export const categories: Category[] = [
  {
    slug: "ent",
    name: "娱乐圈内幕",
    short: "文娱",
    desc: "舞台与镜头之外的排位逻辑、资源流转与行业潜规则，从片场到晚会的真实切片。",
    cover:
      "https://readdy.ai/api/search-image?query=backstage%20of%20a%20grand%20glowing%20television%20stage%20with%20spotlights%2C%20blurred%20showgirls%20and%20technicians%20walking%20in%20dim%20warm%20corridor%2C%20cinematic%20editorial%20photojournalism%2C%20warm%20amber%20and%20crimson%20tone%2C%20film%20grain%2C%20moody%20dramatic%20lighting&width=900&height=600&seq=cat-ent-01&orientation=landscape",
    alt: "娱乐圈内幕晚会的后台灯光与忙碌人群",
  },
  {
    slug: "net",
    name: "互联网背后",
    short: "网络",
    desc: "热搜排序、算法推荐与直播间话术背后，那些被精心设计却鲜少被点破的运作逻辑。",
    cover:
      "https://readdy.ai/api/search-image?query=control%20room%20filled%20with%20glowing%20monitors%20showing%20data%20feeds%20and%20trending%20charts%2C%20analyst%20silhouette%20in%20front%2C%20warm%20dim%20light%2C%20cinematic%20editorial%20photography%2C%20amber%20and%20deep%20brown%20tones%2C%20film%20grain%20moody%20atmosphere&width=900&height=600&seq=cat-net-01&orientation=landscape",
    alt: "互联网背后布满数据大屏的监测控制室",
  },
  {
    slug: "cap",
    name: "商业资本",
    short: "资本",
    desc: "融资尽调、加盟招商与估值游戏里的冰山一角，还原资本决策桌上被遮住的三行小字。",
    cover:
      "https://readdy.ai/api/search-image?query=glass%20boardroom%20at%20dusk%20with%20financial%20charts%20and%20signature%20papers%20on%20dark%20wood%20table%2C%20warm%20low%20light%2C%20cinematic%20corporate%20editorial%20photography%2C%20amber%20and%20ink%20tones%2C%20film%20grain%2C%20serious%20moody%20atmosphere&width=900&height=600&seq=cat-cap-01&orientation=landscape",
    alt: "商业资本昏暗会议室中的报表与签字文件",
  },
  {
    slug: "tech",
    name: "科技幕后",
    short: "科技",
    desc: "从发布会台上的'黑科技'到实验室里的真实进度，拆解产品叙事与工程现实的落差。",
    cover:
      "https://readdy.ai/api/search-image?query=modern%20electronics%20laboratory%20bench%20with%20disassembled%20phone%20circuit%20and%20probes%2C%20warm%20task%20lighting%2C%20cinematic%20technical%20editorial%20photography%2C%20copper%20and%20brown%20tones%2C%20film%20grain%2C%20close%20detail%20moody%20light&width=900&height=600&seq=cat-tech-01&orientation=landscape",
    alt: "科技幕后实验室工作台上被拆解的电路与探针",
  },
  {
    slug: "mso",
    name: "民生观察",
    short: "民生",
    desc: "从物业费上涨到旧衣回收，把与我们生活贴近却又容易忽略的真实一角摊开来看。",
    cover:
      "https://readdy.ai/api/search-image?query=quiet%20chinese%20residential%20community%20courtyard%20in%20late%20afternoon%20warm%20light%2C%20residents%20and%20notice%20board%20by%20the%20wall%2C%20cinematic%20slice%20of%20life%20editorial%20photography%2C%20warm%20sand%20and%20amber%20tones%2C%20film%20grain%2C%20nostalgic%20moody%20atmosphere&width=900&height=600&seq=cat-mso-01&orientation=landscape",
    alt: "民生观察社区傍晚暖光下的居民楼与公告栏",
  },
  {
    slug: "urb",
    name: "都市异闻",
    short: "都市",
    desc: "深夜便利店外的临时占位与写字楼里的秩序博弈，藏在城市夹缝中的奇闻与规则。",
    cover:
      "https://readdy.ai/api/search-image?query=empty%20neon%20city%20alley%20at%20night%20with%20convenience%20store%20sign%20and%20wet%20street%20reflection%2C%20warm%20and%20amber%20glow%2C%20cinematic%20urban%20editorial%20photography%2C%20film%20grain%2C%20mysterious%20moody%20atmosphere&width=900&height=600&seq=cat-urb-01&orientation=landscape",
    alt: "都市异闻深夜暖光便利店与湿漉漉的街巷",
  },
];

export const getCategory = (slug: string): Category | undefined =>
  categories.find((c) => c.slug === slug);